import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=c6739fbc&scoped=true"
import script from "./parameter.vue?vue&type=script&lang=js"
export * from "./parameter.vue?vue&type=script&lang=js"
import style0 from "./parameter.vue?vue&type=style&index=0&id=c6739fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6739fbc",
  null
  
)

export default component.exports